import script from "./RewardScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardScreen.vue?vue&type=script&setup=true&lang=js"

import "./RewardScreen.vue?vue&type=style&index=0&id=224dbcc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224dbcc2"]])

export default __exports__